import { wrapExperiments } from 'commonUtils/experiments';
import { CREDIT_SELECTION_ABC_EXPERIMENT_IDS } from 'constants/experiments';

/** Experiments => string Оставляет только эксперименты, которые используются в подборе кредита */
export const getOnlySelectionAbExperimentsString = <T extends Record<string, string>>(experiments: T): string => {
  const data = {} as T;
  const selection_experiments = Object.values(CREDIT_SELECTION_ABC_EXPERIMENT_IDS).reduce<T>((prev, current) => {
    if (typeof experiments[current] !== 'undefined') {
      return {
        ...prev,
        [current]: experiments[current],
      };
    }
    return prev;
  }, data);

  return wrapExperiments(selection_experiments);
};
